import { isBlank } from './empty-checks';

export function attachmentName(attachment) {
  if(isBlank(attachment?.s3Key)) return '';

  const index = attachment.s3Key.lastIndexOf('/') + 1;

  return attachment.s3Key.substring(index);
}